$(document).ready(function(){
    $(document).foundation();


    if ($(".social-buttons").length) {
        $( '.social-buttons a' ).click(function( e ){
            e.preventDefault();
            m40_socialShare( this.href, 640, 480 );
        });
        window.m40_socialShare = function(url, winWidth, winHeight) {
            var winTop = (window.innerHeight / 2) - (winHeight / 2);
            var winLeft = (window.innerWidth / 2) - (winWidth / 2);
            window.open(url, 'm40_sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
            return false;
        };
    }

    if ($(".chosen").length) {
        $(".chosen > .ginput_container > select").chosen();
    }

    if ($(".flatpickr").length) {
        $(".flatpickr > .ginput_container > input").flatpickr();
    }

    // Search Container - Trigger is in secondary-navigation.twig
    $(".search-trigger").on('click', function(e) {
        e.preventDefault();
        var nav_span = $(".nav-span");
        nav_span.removeClass("nav-cross");
        nav_span.addClass("nav-lines");
        $('body').removeClass('nav-toggle-is-active');
        
        $(".search-container").toggleClass("active");
       // $(".search-active-overlay").toggleClass("fade-content");
        //$(".header_overlay").toggleClass("swapsearch");
        //$("html").toggleClass("no-scroll");
    });

    $(".search-close").on('click', function(e) {
        e.preventDefault();
        $(".search-container").removeClass("active");
        //$(".search-active-overlay").removeClass("fade-content");
        //$(".header_overlay").removeClass("swapsearch");
        //$("html").removeClass("no-scroll");
    });


    // esc key action
    $(document).keyup(function(e) {
        if (e.keyCode == 27) { // Esc
            var nav_span = $(".nav-span");
            nav_span.removeClass("nav-cross");
            nav_span.addClass("nav-lines");
            $('body').removeClass('nav-toggle-is-active');
            $('.search-container').removeClass('active');
        }
    });


    var $emailCaptureModal = $('#emailCaptureModal');


    jQuery(document).bind('gform_confirmation_loaded', function(event, formId){
        //$emailCaptureModal.foundation('close');
    });

    $emailCaptureModal.find( '.close-reveal-modal' ).click(function () {
        $emailCaptureModal.foundation('close');
    });

    $( '.close-reveal-modal').click(function () {
        var id = $( this ).parents( '.reveal').first().attr( 'id');
        $( '#' + id ).foundation('close');
    });

});